// extracted by mini-css-extract-plugin
export var noSpinners = "_mv-6";
export var percentageInput = "_mv-7";
export var variantColor1 = "_mv-0";
export var variantColor2 = "_mv-1";
export var variantColor3 = "_mv-2";
export var variantColor4 = "_mv-3";
export var variantColor5 = "_mv-4";
export var variantColor6 = "_mv-5";